import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { Event } from "../../../../../../models/event";
import { EventType } from "../../../../../../models/event-type";
import { RoleControllerService } from "../../../../../../services/role-controller/role-controller.service";
import { Store } from "../../../../../../services/store.service";
import { BaseError } from "../../../../base-error";
import { QueryBuilder } from "../../../../../utils/query-builder/query-builder";

@Component({
    selector: "role-flow-determinant",
    templateUrl: "./role-flow-determinant.component.html",
    providers: [RoleControllerService],
})

export class RoleFlowDeterminantComponent extends BaseError implements OnInit {

    @Input() public roles: any[];
    @Output() public modalClosedEvent = new EventEmitter();
    @Output() public determinantSelectionChanged = new EventEmitter();
    @Output() public showDeterminantsFilter = new EventEmitter();
    @Input() public determinantMapById: { [key: string]: string } = {};
    public rolesDeterminantsList: any[] = [];
    public all: boolean = true;

    constructor(private roleController: RoleControllerService,
                public store: Store,
                private route: ActivatedRoute, toastr: ToastrService) {
        super(toastr);
    }

    public ngOnInit(): void {
        if (this.determinantMapById) {
            this.populateDeterminants();
        }
        const selects = localStorage.getItem("roleDeterminantSelection");
        if (selects) {
            const elements = JSON.parse(selects);
            if (elements && elements.length) {
                elements.forEach((e) => {
                    this.rolesDeterminantsList.forEach((d) => {
                        if (e.determinantId) {
                            if (d.determinantId === e.determinantId) {
                                d.checked = e.checked;
                            }
                        } else {
                            d.checked = true;
                        }
                    });
                });
                setTimeout(() => this.checkBranchs());
            }
        } else {
            this.saveChanges();
        }
    }

    public roleDeterminants(id, roleDets): void {
        if (roleDets !== null && roleDets !== "") {
            JSON.parse(roleDets).forEach((det, i) => {
                det.items.forEach((indet, j) => {
                    if (indet.determinantId) {
                        this.rolesDeterminantsList.push({
                            name: this.determinantMapById[indet.determinantId] || QueryBuilder.findDeterminantName(indet, this.determinantMapById),
                            checked: true,
                            determinantId: indet.determinantId,
                            parent: id,
                        });
                    }
                });
            });
        }
    }

    public getAlStatus() {
        let areAllChecked = true;
        this.rolesDeterminantsList?.forEach((d) => {
            if (d.checked === false) {
                areAllChecked = false;
            }
        });
        this.all = areAllChecked;
    }

    public populateDeterminants(): void {
        this.roles.forEach((r, i) => {
            if (r[0] !== null && r[0] !== undefined) {
                r.forEach((item) => {
                    if (item.jsonDeterminants != null) {
                        this.roleDeterminants(item.id, item.jsonDeterminants);
                    }
                });
            }
        });
        this.rolesDeterminantsList = Array.from(new Set(this.rolesDeterminantsList.map((a) => a.determinantId)))
            .map((determinantId) => {
                return this.rolesDeterminantsList.find((a) => a.determinantId === determinantId);
            });
        this.getAlStatus();
        this.showDeterminantsFilter.emit(this.rolesDeterminantsList.length > 0);
    }

    public determinantToggle(det): void {
        det.checked = !det.checked;
        if (!det.checked) {
            this.all = false;
        } else {
           this.getAlStatus();
        }
        this.checkBranchs();
    }

    public selectAll(): void {
        this.rolesDeterminantsList.forEach((d) => {
            d.checked = true;
        });
        this.all = true;
        this.checkBranchs();
    }

    public unselectAll(): void {
        this.rolesDeterminantsList.forEach((d) => {
            d.checked = false;
        });
        this.all = false;
        this.checkBranchs();
    }

    public checkBranchs(): void {
        this.determinantSelectionChanged.emit(this.rolesDeterminantsList);
        this.saveChanges();
    }

    public saveChanges(): void {
        localStorage.setItem("roleDeterminantSelection", JSON.stringify(this.rolesDeterminantsList));
    }

}
